import VisitorsByMonthChart from './VisitorsByMonthChart';
import VisitsByMonthChart from './VisitsByMonthChart';

const TrafficPastYearsPanel = () => {
  return (
    <>
      <VisitorsByMonthChart />
      <VisitsByMonthChart />
    </>
  );
};

export default TrafficPastYearsPanel;
